var exports = {
  "n": "xe533113f--48594d--link",
  "x": "xe533113f--48594d--button",
};

module.exports = exports;
